export default __webpack_public_path__ + "static/media/Shau's Reflection.f31a7383.jpg";